import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DirectionType} from '../../enum/DirectionType';
import {Order} from '../../models/Order';
import {NgIcon, provideIcons} from '@ng-icons/core';
import {
  heroArrowDown,
  heroArrowUp,
  heroChevronDown,
  heroChevronUp,
  heroChevronUpDown
} from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-sort-button',
  standalone: true,
  imports: [
    NgIcon
  ],
  providers: [
    provideIcons({
      heroArrowDown,
      heroArrowUp,
      heroChevronUpDown,
      heroChevronUp,
      heroChevronDown,
    })
  ],
  template: `
    <div id="sort-button" class="flex" (click)="setOrder()">
      <div class="link" [class.text-blue-500]="this.order.attribute === this.column">{{label}}</div><ng-icon [name]="getIconClass()" size="16"/>
    </div>
  `,
  styles: `
    #sort-button {
      cursor: pointer;
    }
  `
})
export class SortButtonComponent implements OnInit {

  @Input() label = '';
  @Input() column = '';
  @Input() order: Order = new Order('', DirectionType.asc);
  @Output() orderChange = new EventEmitter<Order>();

  ngOnInit(): void {}

  setOrder(): void{
    if (this.order.attribute !== this.column){
      this.order.direction = DirectionType.asc;
    }
    else{
      this.order.direction = this.order.direction === DirectionType.asc ? DirectionType.desc : DirectionType.asc;
    }
    this.order.attribute = this.column;
    this.orderChange.emit(this.order);
  }

  getIconClass(): string{
    if (this.order.attribute !== this.column){
      return 'heroChevronUpDown';
    }
    else if(this.order.direction === DirectionType.asc){
      return 'heroChevronDown';
    }
    else{
      return 'heroChevronUp';
    }
  }

}
